import * as Turbo from '@hotwired/turbo';

// Turbo Drive, scoped to the tenant case-center question flow.
//
// This bundle is only loaded on case-center pages (see layouts/base.blade.php), and we
// keep Turbo from auto-intercepting link/form clicks — the ONLY thing that triggers a
// smooth Turbo visit is Livewire's own redirect, routed through the Turbolinks shim
// below. That keeps the blast radius tiny.
Turbo.session.drive = false;

// Livewire 2's compiled redirect() does:
//   window.Turbolinks && window.Turbolinks.supported ? Turbolinks.visit(url) : location.href = url
// Turbo is Turbolinks' successor, so this shim turns each per-question Livewire redirect
// (BasicForm::continue()/back() -> redirect()->route('basic-form', ...)) into a smooth
// Turbo visit — with NO PHP or Livewire-internals changes. Only case-center targets are
// Turbo-visited; navigating OUT of the flow does a normal full page load into a
// Turbo-less page.
window.Turbolinks = {
    supported: true,
    visit(url) {
        try {
            const path = new URL(url, window.location.origin).pathname;
            if (/\/module\/\d+\/question\/\d+|\/case-center/.test(path)) {
                Turbo.visit(url);
                return;
            }
        } catch (e) {
            /* fall through to a full load */
        }
        window.location.href = url;
    },
};

// Google Maps is loaded via an inline <script src> inside the address components, which
// sits in Turbo's swap region. Once it's on window, strip it from the incoming body so a
// revisit doesn't reload the API ("included multiple times" warning + double callbacks).
//
// x-ignore: Alpine's MutationObserver initializes the swapped-in body BEFORE our
// turbo:load handler has restarted Livewire — so components that need Livewire at
// init (entangle()/$wire in x-data) throw and come up dead. Gate the incoming body
// with x-ignore so that first pass skips it; turbo:load below lifts the gate and
// initializes the tree exactly once, after Livewire.restart().
document.addEventListener('turbo:before-render', (event) => {
    if (!event.detail?.newBody) return;
    event.detail.newBody.setAttribute('x-ignore', '');
    if (window.google?.maps?.places) {
        event.detail.newBody
            .querySelectorAll('script[src*="maps.googleapis.com"]')
            .forEach((s) => s.remove());
    }
});

// After each Turbo visit swaps the <body>: reconnect Livewire to the fresh component
// roots (Livewire 2 binds on DOMContentLoaded, which Turbo does not refire), then lift
// the x-ignore gate set in turbo:before-render and initialize Alpine on the new body
// EXACTLY ONCE. @livewireScripts + app.js live in a data-turbo-permanent region, so
// the runtimes boot exactly once.
//
// Why the gate + single manual pass (do not "simplify" either half away):
//  - Without the gate, Alpine's MutationObserver initializes the swapped body before
//    Livewire.restart() has wired the new roots — x-data using entangle()/$wire
//    throws and those inputs come up dead.
//  - With the gate but ALSO an unconditional initTree (the old code), every Alpine
//    component got TWO scopes after each Turbo visit: clicks mutated one scope while
//    x-show/x-transition read the other — the Aurora tray widget rendered but ignored
//    every click until a hard refresh (plus "TypeError: e is not a function" from
//    Alpine transition cleanup on poll morphs).
//
// The hasAttribute guard doubles as the initial-load skip: only Turbo-rendered
// bodies carry x-ignore, so the first (normal) page load boots untouched.
document.addEventListener('turbo:load', () => {
    if (!document.body.hasAttribute('x-ignore')) return;

    if (typeof window.Livewire?.restart === 'function') {
        window.Livewire.restart();
    }

    document.body.removeAttribute('x-ignore');
    delete document.body._x_ignore;
    if (typeof window.Alpine?.initTree === 'function') {
        window.Alpine.initTree(document.body);
    }
});
